import BottomSheetWebViewWrapper from '@di-shared/features/common/BottomSheetWebViewWrapper';
import React from 'react';
import SafeDrivingAgreeBottomSheetKr, {
  SafeDrivingAgreeBottomSheetKrProps,
} from '@di-shared/features/safe-driving/kr/SafeDrivingAgreeBottomSheet.kr';

const BOTTOM_SHEET_FALLBACK_HEIGHT = 350;

function SafeDrivingAgreeBottomSheetPage() {
  const {vin, termsData} = (window as any).data as SafeDrivingAgreeBottomSheetKrProps;

  return (
    <BottomSheetWebViewWrapper bottomSheetFallbackHeight={BOTTOM_SHEET_FALLBACK_HEIGHT}>
      <SafeDrivingAgreeBottomSheetKr
        vin={vin}
        termsData={termsData}
      />
    </BottomSheetWebViewWrapper>
  );
}

export default SafeDrivingAgreeBottomSheetPage;
